"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function equa(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M12.5399 7.55859C12.5399 7.55859 9.44469 8.01309 8.99394 11.4533C8.99394 11.4533 8.51544 15.3038 12.4499 16.3433C12.7224 16.4149 13.003 16.4509 13.2847 16.4506H13.4782C13.8787 16.4506 14.2627 16.6111 14.5462 16.8961C14.8297 17.1811 14.9887 17.5681 14.9887 17.9716C14.9914 18.3535 14.8493 18.7223 14.591 19.0037C14.3327 19.2851 13.9775 19.4581 13.5967 19.4881C11.6624 19.6186 9.06669 18.6691 7.38219 16.3861C7.38219 16.3861 4.08294 11.6423 7.67844 7.28334C8.52692 6.24709 9.63324 5.45246 10.8862 4.97934C12.3637 4.42659 14.5282 4.07109 16.4069 5.54634C16.4069 5.54634 18.9217 7.49409 17.6324 10.6741C17.6324 10.6741 16.7294 13.2053 13.6349 13.4003L13.2052 13.3763C13.0016 13.371 12.8016 13.3219 12.6186 13.2325C12.4356 13.1431 12.274 13.0154 12.1447 12.8581C12.0148 12.7001 11.9199 12.5163 11.8665 12.3188C11.8131 12.1214 11.8024 11.9148 11.8349 11.7128C11.8869 11.385 12.0514 11.0855 12.3003 10.8658C12.5491 10.6461 12.8667 10.52 13.1984 10.5091L13.6349 10.4791C13.6349 10.4791 15.1177 10.4146 14.9887 8.66184C14.9887 8.66184 14.8597 7.10409 12.5392 7.55934", fill: color }));
}
exports["default"] = equa;
//# sourceMappingURL=equa.js.map